module.exports = __webpack_public_path__ + "img/art2.f00b27c7.png";